import { useContext } from 'react';

import { AuthContextValue } from '@/providers/auth/types';
import { AuthContext } from '@/providers/auth/types';

export const useAuth = (): AuthContextValue => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within <AuthProvider>');
  return ctx;
};
